'use client';
import { createStyles, rem, xref } from '@s7/styles';
import { IDENT_ACCORDION_CONTROL } from './AccordionControl.contract.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const xrefChevron = xref(IDENT_ACCORDION_CONTROL, 'chevron');
var useStyles = createStyles((theme, { transitionDuration, chevronPosition, chevronSize })=>({
        chevron: {
            boxSizing: 'border-box',
            ref: xrefChevron,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: rem(chevronSize),
            height: rem(chevronSize),
            minWidth: rem(chevronSize),
            transition: `transform ${transitionDuration}ms ease`,
            '&[data-rotate]': {
                transform: 'rotate(180deg)'
            },
            borderRadius: theme.fn.borderRadius()
        },
        label: _extends({
            flex: 1,
            margin: 0,
            paddingTop: rem(20),
            paddingBottom: rem(20)
        }, theme.fn.typography({
            variant: 'heading',
            size: 'sm1',
            weight: 'semibold',
            truncate: true
        })),
        control: {
            boxSizing: 'border-box',
            cursor: 'pointer',
            [`&:focus-visible .${xrefChevron}`]: theme.fn.border({
                color: theme.palette.primary.mid,
                width: rem(3)
            }),
            display: 'flex',
            alignItems: 'center',
            flexDirection: chevronPosition === 'right' ? 'row-reverse' : 'row',
            width: '100%',
            textAlign: 'left',
            color: theme.palette.text.quaternary,
            '&:disabled': {
                opacity: 0.4,
                cursor: 'not-allowed',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        }
    }));

export { useStyles as default };
//# sourceMappingURL=AccordionControl.styles.js.map
